import axiosInstance from "../../../utils/axios";
import {
  REDIRECT,
  GET_NOTIFICATION,
  GET_NOTIFICATIONS,
  POP_UP_OPEN,
  CHANGE_NOTIFICATION_READ_STATUS,
  NOTIFICATION_FAIL,
} from "../actions/types";
import { tokenConfig } from "./auth";

export const getNotification =
  ({ id }) =>
  (dispatch, getState) => {
    axiosInstance
      .get(`notifications/${id}`, tokenConfig(getState))
      .then((res) => {
        dispatch({
          type: GET_NOTIFICATION,
          payload: res.data.data,
        });
      })
      .catch((err) => {
        dispatch({
          type: NOTIFICATION_FAIL,
          payload: err.response,
        });
      });
  };

export const changeNotificationReadStatus =
  ({ id }) =>
  (dispatch, getState) => {
    const data = JSON.stringify({
      data: { isRead: true },
    });
    axiosInstance
      .put(`notifications/${id}`, data, tokenConfig(getState))
      .then((res) => {
        dispatch({
          type: CHANGE_NOTIFICATION_READ_STATUS,
          payload: res.data.data,
        });
      })
      .catch((err) => {
        dispatch({
          type: GET_NOTIFICATION,
          payload: err.response,
        });
      });
  };

export const getNotifications = () => (dispatch, getState) => {
  axiosInstance
    .get(`notifications?sort=createdAt:DESC`, tokenConfig(getState))
    .then((res) => {
      dispatch({
        type: GET_NOTIFICATIONS,
        payload: res.data.data,
      });
    })
    .catch((err) => {
      dispatch({
        type: NOTIFICATION_FAIL,
        payload: err.response,
      });
    });
};

export const openPopUp = () => (dispatch) => {
  dispatch({
    type: POP_UP_OPEN,
    payload: null,
  });
};

export const redirect = () => (dispatch) => {
  dispatch({
    type: REDIRECT,
    payload: null,
  });
};
